import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';

import PrizeForm from './PrizeForm.jsx';
import BoxMessage from './BoxMessage.jsx';
import { Button } from '../../../shared/FormStyles';
import {
  FormWrapper,
  FormSection,
  Container,
  Footer,
} from './StyledComponents';
import usePrizeForm from './usePrizeForm';
import UserPreview from './userPreview.jsx';

function FormActions({
  isShow,
  setIsShow,
  handleSubmit,
  resetForm,
  onEndEarlySubmit,
  isValid,
}) {
  const { t } = useTranslation('prizes');
  const queryClient = useQueryClient();

  const cancelEdit = () => {
    setIsShow(true);
    queryClient.invalidateQueries(['getRaffle']);
    resetForm();
  };

  const submit = () => {
    handleSubmit();
    if (isValid) {
      setIsShow(true);
    }
  };

  return isShow ? (
    <Footer>
      <Button
        variant="tertiary"
        onClick={() => {
          setIsShow(false);
        }}
      >
        {t('live.edit')}
      </Button>
      <Button mt="12px" variant="containedBlue" onClick={onEndEarlySubmit}>
        {t('live.pickWinnersNow')}
      </Button>
    </Footer>
  ) : (
    <Footer>
      <Button variant="containedBlue" type="submit" onClick={submit}>
        {t('live.save')}
      </Button>
      <Button mt="12px" variant="tertiary" onClick={cancelEdit}>
        {t('live.cancel')}
      </Button>
    </Footer>
  );
}

const Live = ({ raffle }) => {
  const [isShow, setIsShow] = useState(true);
  const { t } = useTranslation('prizes');
  const {
    handleSubmit,
    resetForm,
    onEndEarlySubmit,
    values,
    isValid,
    ...form
  } = usePrizeForm({
    prizeValues: raffle,
  });

  return (
    <FormWrapper>
      <FormSection>
        <BoxMessage
          title={t('prizes:live.titleBox')}
          message={t('prizes:live.messageBox', {
            ends_date: raffle.remainingInfo
              ? values.remainingInfo.pick_winners_starting
              : '',
          })}
        />
        <Container>
          <PrizeForm isShow={isShow} values={values} {...form} />
          <FormActions
            handleSubmit={handleSubmit}
            isShow={isShow}
            values={values}
            setIsShow={setIsShow}
            resetForm={resetForm}
            onEndEarlySubmit={onEndEarlySubmit}
            isValid={isValid}
          />
        </Container>
      </FormSection>
      <UserPreview raffle={values} />
    </FormWrapper>
  );
};

export default Live;
